import React from "react";
import { TextInput } from "web-ui/juicy";
import { LegacyButton as Button } from "web-ui/legacy";

/* eslint-disable react/jsx-no-literals */

export const EditTextDialog = ({
  editType,
  isVisible,
  oldValue,
  onCancel,
  onDelete,
  onSubmit,
}: {
  editType: string | undefined;
  isVisible: boolean;
  oldValue: string;
  onCancel: () => void;
  onDelete: () => void;
  onSubmit: (newText: string | undefined) => void;
}) => {
  const [text, setText] = React.useState<string>(oldValue);

  return isVisible ? (
    <div>
      <TextInput
        autoFocus={true}
        onChange={e => setText(e.target.value)}
        placeholder={`New ${editType ?? "text"} for ${oldValue}`}
        type="text"
        value={text ?? ""}
      />
      <Button
        color="snow"
        onClick={() => {
          onCancel();
        }}
        variant="solid"
      >
        Cancel
      </Button>
      <Button
        color="owl"
        onClick={() => {
          onSubmit(text);
        }}
        variant="solid"
      >
        Edit
      </Button>
      <Button
        color="macaw"
        onClick={() => {
          onDelete();
        }}
        variant="solid"
      >
        Delete
      </Button>
    </div>
  ) : null;
};
